import { render, staticRenderFns } from "./AMHatsu.vue?vue&type=template&id=2964f9b7&scoped=true"
import script from "./AMHatsu.vue?vue&type=script&lang=ts"
export * from "./AMHatsu.vue?vue&type=script&lang=ts"
import style0 from "./AMHatsu.vue?vue&type=style&index=0&id=2964f9b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964f9b7",
  null
  
)

export default component.exports